// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const wishiwashi_solo: PokeData = {
  "id": 746,
  "name": "wishiwashi-solo",
  "height": 2,
  "weight": 3,
  "base_experience": 61,
  "types": [
    PokeType.WATER
  ],
  "api_moves": [
    "take-down",
    "double-edge",
    "growl",
    "water-gun",
    "hydro-pump",
    "feint-attack",
    "beat-up",
    "uproar",
    "helping-hand",
    "endeavor",
    "dive",
    "brine",
    "aqua-ring",
    "aqua-tail",
    "soak",
    "tearful-look"
  ],
  "moves": [
    "growl",
    "hydro-pump",
    "brine",
    "aqua-tail",
    "aqua-jet",
    "bubble",
    "rain-dance",
    "life-dew",
    "whirlpool",
    "bubble-beam",
    "liquidation",
    "water-spout",
    "aqua-cutter"
  ],
  "evolution_chain": {
    "id": 384,
    "item": null,
    "species": [
      {
        "name": "wishiwashi",
        "order": 746,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 68,
    "speed": 80,
    "ability_power": 50
  },
  "stat_changes": [],
  "catch_rate": 60,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
